import { useId } from "react";

import { cn } from "@/lib/utils";
import { Switch } from "@/components/ui/switch";
import { useAccessibility } from "@/components/ui/AccessibilityProvider";

interface ReducedMotionToggleProps {
  className?: string;
  label?: string;
  showLabel?: boolean;
}

export function ReducedMotionToggle({
  className,
  label = "Reduce motion",
  showLabel = true,
}: ReducedMotionToggleProps) {
  const labelId = useId();
  const descriptionId = useId();
  const { reducedMotionEnabled, setReducedMotionEnabled } = useAccessibility();

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <span
        id={labelId}
        className={cn(
          "text-sm font-medium text-muted-foreground",
          !showLabel && "sr-only"
        )}
      >
        {label}
      </span>
      <Switch
        aria-labelledby={labelId}
        aria-describedby={descriptionId}
        checked={reducedMotionEnabled}
        onCheckedChange={setReducedMotionEnabled}
      />
      <span id={descriptionId} className="sr-only">
        {reducedMotionEnabled
          ? "Reduced motion is enabled. Animations are minimized."
          : "Reduced motion is disabled. Animations are fully enabled."}
      </span>
    </div>
  );
}
